module.exports = __webpack_public_path__ + "static/media/icn-add-participant-48px-48px-grey.3ed2c358.svg";